import { render, staticRenderFns } from "./TableRowTestedToTreatmentConversionRate.vue?vue&type=template&id=128d9a18&lang=pug&"
import script from "./TableRowTestedToTreatmentConversionRate.vue?vue&type=script&lang=js&"
export * from "./TableRowTestedToTreatmentConversionRate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/workspace/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('128d9a18')) {
      api.createRecord('128d9a18', component.options)
    } else {
      api.reload('128d9a18', component.options)
    }
    module.hot.accept("./TableRowTestedToTreatmentConversionRate.vue?vue&type=template&id=128d9a18&lang=pug&", function () {
      api.rerender('128d9a18', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "public/js/src/app/components/allergy-kpis/tracking-sheet/table-rows/TableRowTestedToTreatmentConversionRate.vue"
export default component.exports